// TSS vite/03 §"Query keys convention" — tuples, entity-name first.

export const clientKeys = {
    all:      ['clients'],
    list:     (filters) => ['clients', 'list', filters],
    detail:   (id)      => ['clients', 'detail', id],
    holdings: (id)      => ['clients', 'holdings', id],
};
